import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import {
  EnvironmentProviders,
  ImportProvidersSource,
  Provider,
} from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import {
  ConfigLoader,
  DefaultConfigLoader,
  HttpClientLoaderTranslation,
  OAuthInterceptor,
  RestService,
  SettingsService,
  W3hostnameInterceptor,
} from '@infodata-group/inf-commons';
import {
  CustomRestService,
  CustomServerSettingsService,
} from '@monorepo-projects/alwayson-shared';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { EditorModule } from '@tinymce/tinymce-angular';

export const commonsProvidersFrom: ImportProvidersSource[] = [
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpClientLoaderTranslation,
      deps: [HttpClient],
    },
  }),
  GoogleMapsModule,
  EditorModule,
];

export const commonsProviders: Array<Provider | EnvironmentProviders> = [
  { provide: ConfigLoader, useClass: DefaultConfigLoader },
  { provide: SettingsService, useClass: CustomServerSettingsService },
  { provide: RestService, useClass: CustomRestService },
  { provide: HTTP_INTERCEPTORS, useClass: OAuthInterceptor, multi: true },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: W3hostnameInterceptor,
    multi: true,
  },
];
